/*global globalAngularTrackingData:true b2bFreetrialConstraint:readonly google:readonly*/

angular.module('b2bLoginApp.controllers').controller('AreasController', ["$scope", "$uibModal", "$timeout", "$http", "$templateCache", "$q", "$filter", "Area", "TranslationService", "Rate", "$location", function($scope, $uibModal, $timeout, $http, $templateCache, $q, $filter, Area, TranslationService, Rate, $location) {
    $scope.navigation = [];
    $scope.regions = [];
    $scope.formScope = {
        formController: null
    };
    $scope.subscriptionsSettings = [];

    $scope.updateNavigation = function(target, siteId) {
        $scope.navigation[siteId].targetTab = target;
    };

    $scope.sendPageViewEvent = function () {
        try {
            globalAngularTrackingData.pageTemplate = 'targeting';
            window.SelfServiceGATracker.sendPageViewEvent(globalAngularTrackingData);
        } catch (error) {
            console.error('Error while sending data to GA: ', error);
        }
    };

    $scope.sendPageViewEvent();

    var isInitialCheckDone = false;

    $scope.checkUrlAndOpenDialogIfNeeded = function() {
        if (!angular.isDefined($scope.companySites) || isInitialCheckDone) {
            return;
        }

        var params = $location.search();
        const shouldOpenModal = params.openEditModalParam === 'true';

        if (shouldOpenModal) {
            var targetTab = params.targetTab || 'from';
            var modalTab = params.modalTab || 'area';
            var siteId = params.siteId || '';

            $scope.openEditDialog(siteId, targetTab, modalTab);
        }

        isInitialCheckDone = true;
    };

    $scope.$watch('companySites', function() {
        var sitesWithoutAreas = $scope.getCompanySitesIds().filter(function (companySiteId) {
            for (var i = 0; i < $scope.siteAreas.length; i++) {
                if ($scope.siteAreas[i].site.id === companySiteId) {
                    return false;
                }
            }

            return true;
        });

        if (sitesWithoutAreas.length > 0) {
            $scope.getAreas();
        }

        if (angular.isDefined($scope.companySites)) {
            angular.forEach($scope.companySites, function (companySite) {
                if (!angular.isDefined($scope.navigation[companySite.id])) {
                    $scope.navigation[companySite.id] = {};
                }
                $scope.navigation[companySite.id].targetTab = 'from';
            });
        }

        $scope.checkUrlAndOpenDialogIfNeeded();
    });

    $scope.getCompanySites();

    $scope.hasTrialLimit = function(company) {
        if (company.businessUnit === 'home') {
            return false;
        }
        return company.status === 14 || company.status === 16|| company.status === 17;
    };

    $scope.openCategorySelectionDialog = function () {
        var template = '/account/areas/' + $scope.company.id + '/category-selection.html';

        var modal = $uibModal.open({
            templateUrl: template,
            scope: $scope,
            backdrop: 'static',
            keyboard: false,
            size: 'md',
            controller: ["$scope", function ($scope) {
                $scope.categoryRates = [];

                $scope.$watch('categoryId', function (categoryId) {
                    if (categoryId === undefined) {
                        return;
                    }

                    if (!$scope.categoryRates[categoryId]) {
                        Rate.query({siteId: categoryId}, function (data) {
                            $scope.categoryRates[categoryId] = data.item;
                        });
                    }
                });

                $scope.save = function() {
                    var postTarget = '/account/' + $scope.company.id + '/targeting/add-site/' + $scope.categoryId;

                    $http.post(postTarget, {}).then(function(response){
                        if (response.data.result === 'success') {
                            $scope.getCompanySites();
                            $templateCache.remove(template);
                            modal.close();
                            $scope.openEditDialog($scope.categoryId, 'from', 'radius');
                        }
                    });
                }
            }]
        });
    };

    $scope.openRemoveDialog = function(categoryId) {
        var template = '/account/' + $scope.company.id + '/areas/remove.html?categoryId=' + categoryId;
        $uibModal.open({
            templateUrl: template,
            scope: $scope,
            keyboard: false,
            size: 'md',
            controller: ["$scope", function($scope) {
                $scope.confirm = function() {
                    $http.post('/account/'+$scope.company.id+'/areas/remove', { categoryId:categoryId }).then(function(response){
                        if (response.data.result === 'success') {
                            window.location.reload();
                        }
                    });
                }
            }]
        });
    }

    $scope.openEditDialog = function(siteId, targetTab, modalTab) {
        var target = targetTab ? targetTab : $scope.navigation[siteId].targetTab;
        var template = `/account/${$scope.company.id}/areas/edit.html?type=${target}&siteId=${siteId}`;
        var postTarget = `targeting.json?type=${target}&saveSiteId=${siteId}`;

        // Wait for Google Maps SDK to be ready
        var modal = $uibModal.open({
            templateUrl: template,
            scope: $scope,
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            controller: ["$scope", function($scope) {
                $scope.modalTab = 'area';
                $scope.editing = {
                    subscription: null
                };
                $scope.dropdown = {
                    open: null
                };
                $scope.freetrialOptions = {
                    disabled: function(level) {
                        if ($scope.hasTrialLimit($scope.company) && target === 'from') {
                            var levelMax = typeof b2bFreetrialConstraint.levelMax[level] !== 'undefined' ?
                                b2bFreetrialConstraint.levelMax[level] : 0;
                            return levelMax === 0;
                        }
                        return false;
                    },
                    constraints: b2bFreetrialConstraint
                };

                $scope.removeSubscription = function(targetSubscription) {
                    // var index = $scope.subscriptions.indexOf(targetSubscription);
                    // $scope.subscriptions.splice(index, 1);
                    targetSubscription.deleted = !targetSubscription.deleted;
                };

                var tmpIdCounter = -1;
                $scope.subscriptions = [];

                $scope.initializeRadiusSubscription = function (businessUnitMove, types) {

                    if ($scope.subscriptions.length !== 0) {
                        return;
                    }

                    var subscription = $scope.addSubscription(null, types, businessUnitMove);

                    $scope.onLocationResultUpdated({
                        lat: subscription.lat,
                        long: subscription.long,
                        label: subscription.label,
                        subscriptionId: subscription.id,
                    });

                    if (subscription.lat && subscription.long) {
                        $scope.map.center = {
                            latitude: subscription.lat,
                            longitude: subscription.long
                        };
                    }

                    return subscription;
                }

                $scope.addSubscription = function(radius, types, businessUnitMove) {
                    var simpleTypes = {};
                    angular.forEach(types, function(value, key) {
                        simpleTypes[key] = true;
                    });

                    var getDefaultRadius = function () {
                        var radius = {
                            id: tmpIdCounter,
                            distance: $scope.hasTrialLimit($scope.company) ? b2bFreetrialConstraint.radiusMax : $scope.defaultRadius,
                            types: simpleTypes
                        }

                        var subscriptions = $scope.subscriptions.filter(subscription => !subscription.deleted);
                        if (subscriptions.length === 0) {
                            radius.postcode = $scope.company.postal_code;
                            if ($scope.company.postalCodeLocation) {
                                radius.latitude = $scope.company.postalCodeLocation.lat;
                                radius.longitude = $scope.company.postalCodeLocation.lng;
                            }
                        }

                        return radius;
                    }

                    radius = (typeof radius !== 'undefined' && radius !== null) ? radius : getDefaultRadius();

                    var newSubscription = {
                        id: radius.id,
                        label: businessUnitMove ? '' : radius.postcode,
                        radius: radius.distance,
                        types: radius.types,
                        deleted: false,
                        lat: businessUnitMove ? '' : radius.latitude,
                        long: businessUnitMove ? '' : radius.longitude,
                    };

                    var subscriptionSettings = {
                        stroke: {
                            color: '#77abe9',
                            opacity: 0.75
                        },
                        fill: {
                            color: '#77abe9',
                            opacity: 0.25
                        },
                    };

                    if (radius.latitude && radius.longitude) {
                        subscriptionSettings.center = {
                            latitude: radius.latitude,
                            longitude: radius.longitude
                        };
                        subscriptionSettings.visible = true;
                    }

                    subscriptionSettings.events = {
                        radius_changed: function(circle) {
                            fitBounds(circle);
                        },
                        center_changed: function(circle) {
                            fitBounds(circle);
                        }
                    };

                    subscriptionSettings.options = {
                        labelContent: newSubscription.postcode,
                        labelClass: 'subscription-label',
                        labelAnchor: '30 10',
                        icon: 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png'
                    };

                    $scope.subscriptions.push(newSubscription);
                    $scope.subscriptionsSettings[newSubscription.id] = subscriptionSettings;
                    tmpIdCounter--;

                    return newSubscription;
                };

                function fitBounds(circle) {
                    if (circle === null || typeof circle.getBounds !== 'function' || circle.getBounds() === null) {
                        return;
                    }
                    if (!$scope.mapControl || typeof $scope.mapControl.getGMap !== 'function') {
                        return;
                    }
                    var gmap = $scope.mapControl.getGMap();
                    if (gmap) {
                        gmap.fitBounds(circle.getBounds());
                    }
                }

                function fitAllSubscriptions() {
                    if (!$scope.mapControl || typeof $scope.mapControl.getGMap !== 'function') {
                        return false;
                    }
                    var gmap = $scope.mapControl.getGMap();
                    if (!gmap) {
                        return false;
                    }
                    var meters = $scope.radiusUnitInMeters || 1000;
                    var bounds = new google.maps.LatLngBounds();
                    var found = false;
                    angular.forEach($scope.subscriptions, function(subscription) {
                        if (subscription.deleted) {
                            return;
                        }
                        var settings = $scope.subscriptionsSettings[subscription.id];
                        if (!settings || !settings.center) {
                            return;
                        }
                        var lat = Number(settings.center.latitude);
                        var lng = Number(settings.center.longitude);
                        if (!isFinite(lat) || !isFinite(lng) || (lat === 0 && lng === 0)) {
                            return;
                        }
                        var center = new google.maps.LatLng(lat, lng);
                        var radiusMeters = (subscription.radius ? subscription.radius : 10) * meters;
                        bounds.union(new google.maps.Circle({ center: center, radius: radiusMeters }).getBounds());
                        found = true;
                    });
                    if (found && !bounds.isEmpty()) {
                        gmap.fitBounds(bounds);
                        return true;
                    }
                    return false;
                }

                function fitSubscription(subscriptionId) {
                    if (typeof google === 'undefined' || !google.maps || !google.maps.Circle) {
                        return;
                    }
                    var settings = $scope.subscriptionsSettings[subscriptionId];
                    if (!settings || !settings.center) {
                        return;
                    }
                    var lat = Number(settings.center.latitude);
                    var lng = Number(settings.center.longitude);
                    if (!isFinite(lat) || !isFinite(lng) || (lat === 0 && lng === 0)) {
                        return;
                    }
                    var subscription = $scope.subscriptions.find(function(s) {
                        return String(s.id) === String(subscriptionId);
                    });
                    var meters = $scope.radiusUnitInMeters || 1000;
                    var radiusMeters = (subscription && subscription.radius ? subscription.radius : 10) * meters;
                    fitBounds(new google.maps.Circle({ center: new google.maps.LatLng(lat, lng), radius: radiusMeters }));
                }

                $scope.toDistanceUnit = function(distance, unit) {
                    return distance * unit;
                };

                var startingLatitude, startingLongitude, startingZoom;

                switch ($scope.company.country) {
                    case 1:                                 // NL
                        startingLatitude    = 52.25489;
                        startingLongitude   = 5.14827;
                        startingZoom        = 8;
                        break;
                    case 2:                                 // BE
                        startingLatitude    = 50.6445;
                        startingLongitude   = 4.6457;
                        startingZoom        = 7;
                        break;
                    case 3:                                 // UK
                        startingLatitude    = 53.87315;
                        startingLongitude   = -2.62730;
                        startingZoom        = 5;
                        break;
                    case 107:                               // IE
                        startingLatitude    = 53.4494762;
                        startingLongitude   = -7.5029786;
                        startingZoom        = 6;
                        break;
                    case 109:                               // IT
                        startingLatitude    = 40.67348;
                        startingLongitude   = 14.77126;
                        startingZoom        = 5;
                        break;
                    case 209:                               // CH
                        startingLatitude    = 46.7985;
                        startingLongitude   = 8.2318;
                        startingZoom        = 6;
                        break;
                    case 228:                               // US
                        startingLatitude    = 39.437340;
                        startingLongitude   = -100.062392;
                        startingZoom        = 3;
                        break;
                    default:                                // Europe
                        startingLatitude    = 49.40960;
                        startingLongitude   = 11.07265;
                        startingZoom        = 4;
                }

                var initialMapFitDone = false;
                $scope.mapControl = {};
                $scope.map = {
                    center: { latitude: startingLatitude, longitude: startingLongitude },
                    zoom: startingZoom,
                    circles: [],
                    refresh: false,
                    options: {
                        gestureHandling: 'cooperative'
                    },
                    events: {
                        idle: function() {
                            if (initialMapFitDone) {
                                return;
                            }
                            if (fitAllSubscriptions()) {
                                initialMapFitDone = true;
                            }
                        }
                    }
                };

                Area.subscriptions({type: target, siteId: siteId}).$promise.then(function (resource) {
                    $scope.regions = resource['region_data'];

                    for (var key in resource['radius_data']) {
                        var radius = resource['radius_data'][key];
                        $scope.addSubscription(radius);
                    }

                    $scope.modalTab = resource['radius_data'].length > 0 ? 'radius' : 'area';
                    $scope.modalTab = modalTab ? modalTab : $scope.modalTab;
                });

                $scope.save = function() {
                    var areas = {};
                    var radiuses = [];
                    getSelectedRecursive($scope.regions, areas);

                    for (var key in $scope.subscriptions) {
                        var subscription = $scope.subscriptions[key];
                        if (subscription.deleted === true && subscription.id < 0) {
                            continue;
                        }
                        radiuses.push(subscription);
                    }

                    $http.post(postTarget, { areas:areas, radiuses:radiuses }).then(function(response){
                        if (response.data.result === 'success') {
                            $templateCache.remove(template);
                            $scope.invalidateAreas();
                            $scope.getAreas();
                            modal.close();
                        }
                    });
                };

                function getSelectedRecursive(regions, subscriptions) {
                    for (var key in regions) {
                        var region = regions[key];
                        for (var typeKey in region.types) {
                            var type = region.types[typeKey];
                            if (type === true) {
                                var regionId = region.id;
                                if (typeof subscriptions[regionId] === 'undefined') {
                                    subscriptions[regionId] = [];
                                }
                                subscriptions[regionId].push(typeKey);
                            }
                        }
                        getSelectedRecursive(region['__children'], subscriptions);
                    }
                }

                $scope.handleUserLocationInput = function (subscriptionId) {
                    $scope.subscriptionsSettings[subscriptionId].visible = false;
                    $scope.formScope.formController['label' + subscriptionId].$setValidity('label', false);
                }

                $scope.defaultRadius = 30;
                $scope.onLocationResultUpdated = function ($value) {
                    $scope.subscriptionsSettings[$value.subscriptionId].center = {
                        latitude: $value.lat,
                        longitude: $value.long
                    };

                    $scope.subscriptionsSettings[$value.subscriptionId].visible = true;
                    if ($scope.formScope.formController['postcode' + $value.subscriptionId]) {
                        $scope.formScope.formController['postcode' + $value.subscriptionId].$setValidity('postcode', true);
                    }

                    if ($scope.formScope.formController['label' + $value.subscriptionId]) {
                        $scope.formScope.formController['label' + $value.subscriptionId].$setValidity('label', true);
                    }

                    $scope.subscriptions.forEach(function (subscription, index) {
                        if ($value.subscriptionId == subscription.id) {
                            $scope.subscriptions[index].lat = $value.lat;
                            $scope.subscriptions[index].long = $value.long;
                            $scope.subscriptions[index].label = $value.label;
                        }
                    });

                    setTimeout(() => {
                        $scope.$apply();
                        $scope.formScope.formController.$setDirty();
                        fitSubscription($value.subscriptionId);
                    }, 500);
                };
            }]
        });
    };

    function getItem(type, subscription)
    {
        for(var key in subscription.types) {
            if (!Object.prototype.hasOwnProperty.call(subscription.types, key)) {
                continue;
            }
            var item = subscription.types[key];
            if (item.name === type) {
                return item;
            }
        }

        return null;
    }

    $scope.getTypeClass = function(type, subscription) {
        var item = getItem(type, subscription);

        if (item == null) {
            return '';
        }

        switch (item.state) {
            case 0:
                return 'sd-icon-xs-waitlist';
            case 1:
                return 'sd-icon-account-status-active';
            default:
                return '';
        }
    };

    $scope.getTitle = function(type) {
        switch (type.state) {
            case 0:
                return TranslationService.trans('targeting.edit.error.region_full');
            case 1:
                return TranslationService.trans('targeting.edit.error.already_receive');
            default:
                return '';
        }
    };

    $scope.getTypeTitle = function(type, subscription) {
        var item = getItem(type, subscription);

        if (item == null) {
            return '';
        }

        switch (item.state) {
            case 0:
                return TranslationService.trans('targeting.edit.error.region_full');
            case 1:
                return TranslationService.trans('targeting.edit.error.already_receive');
            default:
                return '';
        }

    };

    $scope.getDestinationTitle = function(type, subscription) {
        var item = getItem(type, subscription);

        if (item == null) {
            return '';
        }

        if (item.state === 1) {
            return TranslationService.trans('targeting.edit.error.already_receive_destination');
        }

        return '';
    };
}]);
